import { authHeader } from './auth-header';

export function authGetRequest() {
  return ({
    method: 'GET',
    credentials: 'include' as RequestCredentials,
    headers: authHeader()
  });
}
